module.exports = __webpack_public_path__ + "img/plum-financial-services-logo.1b77baf3.svg";